import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import {
  TAIPEI_OFFSET_MINUTES,
  TOKYO_OFFSET_MINUTES,
} from 'src/utils/maintenanceContract';

import { FALLBACK_COPY } from './fallbackCopy';

const pad = (n) => String(n).padStart(2, '0');

// until 是絕對時間點;顯示固定用目標地區的牆上時間(ja → JST,其餘 → 台北),
// 不跟著訪客裝置時區走
export const formatUntil = (until, locale) => {
  const offset = locale === 'ja' ? TOKYO_OFFSET_MINUTES : TAIPEI_OFFSET_MINUTES;
  const shifted = new Date(until.getTime() + offset * 60 * 1000);

  return `${pad(shifted.getUTCMonth() + 1)}/${pad(shifted.getUTCDate())} ${pad(
    shifted.getUTCHours()
  )}:${pad(shifted.getUTCMinutes())}`;
};

const MAINTENANCE_ANIMATION = 'https://cdn.lottielab.com/l/6ZVCorcbw48iHP.json';

function useLottiePlayer() {
  const [Player, setPlayer] = useState(null);

  useEffect(() => {
    let cancelled = false;

    import('@lottielab/lottie-player/dist/cjs/react.js')
      .then((mod) => {
        const Component = mod.default || mod;

        if (!cancelled && Component) {
          setPlayer(() => Component);
        }
      })
      .catch((error) => {
        console.error('[maintenance] failed to load lottie player', error);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return Player;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  min-height: 100vh;
  padding: 0 24px;
  text-align: center;
`;

// 動畫本身是 240x160,等比縮成 180x120 維持原本的高度
const Illustration = styled.div`
  width: 180px;
  height: 120px;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 20px;
  line-height: 1.5;
  color: #111827;
`;

const Description = styled.p`
  margin: 0;
  max-width: 320px;
  font-size: 15px;
  line-height: 1.5;
  color: #6b7280;
`;

const Until = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #9ca3af;
`;

export default function Maintenance({ copy, locale, until }) {
  const Lottie = useLottiePlayer();
  const fallback = FALLBACK_COPY[locale] || FALLBACK_COPY['zh-TW'];
  const title = (copy && copy.title && copy.title.trim()) || fallback.title;
  const description =
    (copy && copy.description && copy.description.trim()) ||
    fallback.description;
  const untilTime = until ? formatUntil(until, locale) : null;

  return (
    <Wrapper>
      {Lottie && (
        <Illustration>
          <Lottie src={MAINTENANCE_ANIMATION} autoplay loop />
        </Illustration>
      )}
      <Title>{title}</Title>
      <Description>{description}</Description>
      {untilTime && <Until>{fallback.until(untilTime)}</Until>}
    </Wrapper>
  );
}
